import { InvestmentGoalsHorizon } from '../../../../types';
export var list = [
    InvestmentGoalsHorizon.SHORT,
    InvestmentGoalsHorizon.MEDIUM,
    InvestmentGoalsHorizon.LONG,
];
